import { render, staticRenderFns } from "./AlternativasData.vue?vue&type=template&id=7f21ee15&"
import script from "./AlternativasData.vue?vue&type=script&lang=js&"
export * from "./AlternativasData.vue?vue&type=script&lang=js&"
import style0 from "./AlternativasData.vue?vue&type=style&index=0&id=7f21ee15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports